import { Component } from '@angular/core';

import { HomePage } from './home/home.page';
import { TestPage } from './test/test.page';
import { Router } from '@angular/router';
import { Platform,MenuController } from '@ionic/angular';


@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent {
  rootPage:any = HomePage;
  constructor(platform: Platform, private router: Router,public menu: MenuController) {
    platform.ready().then(() => {
      
      

      // Okay, so the platform is ready and our plugins are available.
      // Here you can do any higher level native things you might need.
   
      // statusBar.styleDefault();
      // splashScreen.hide();
    });
  }

  goHome() {
    this.menu.close();
    this.router.navigate(["/home"]);
  }

  goAddfriend() {
    this.menu.close();
    this.router.navigate(["/addfriend"]);
  }

  goProfile() {
    this.menu.close();
    this.router.navigate(["/profile"]);
  }

  logout() {
    this.menu.close();
    this.router.navigate(["/login"]);
  }

}

